import { NgModule } from '@angular/core';
import { InputComponent } from './input.component';
import { EtInputDirective } from './et-input.directive';

@NgModule({
  declarations: [InputComponent, EtInputDirective],
  exports: [InputComponent, EtInputDirective],
})
export class InputModule {}
